export const PAPERSIZE_A4_OPTION_VALUE = 'A4'
export const PAPERSIZE_LETTER_OPTION_VALUE = 'Letter'
export const PAPERSIZE_LEGAL_OPTION_VALUE = 'Legal'
